import { EventEmitter, ElementRef } from '@angular/core';
import { CommonService } from '../../common.service';
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../../api.service";
import { PerformanceService } from '../../case-practice-performance/performanceService';
import { ClashService } from '../../case-practice-clash/ClashService';
var CasePracticeStageEndComponent = (function () {
    function CasePracticeStageEndComponent(commonService, el, apiService, route, router, performanceService, clashService) {
        this.commonService = commonService;
        this.el = el;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.performanceService = performanceService;
        this.clashService = clashService;
        this.onExit = new EventEmitter(); //回传关闭事件
        this.onContinue = new EventEmitter(); //回传继续事件
        this.onReport = new EventEmitter(); //回传继续事件
        this.isShowFireworks = true; //一级结果页显示控制
        this.isShowReportLv = false; //二级结果页显示控制
        this.clickAble = false; //按钮点击判断
        this.confirmBtnFlag = true; //查看变革结果按钮兼容参数
        this.isShowLetter = true;
        this.assetsRoute = "../../../assets";
    }
    CasePracticeStageEndComponent.prototype.ngOnInit = function () {
        console.log(this.step);
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        if (this.simulationName == "performance") {
            this.setStageEndDocWithLevelAndStep(this.resultLevel, this.step);
        }
        else if (this.simulationName == "clash") {
            this.resultLevel = 4;
        }
    };
    CasePracticeStageEndComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'transparent'
        });
        this.enableClickPreview('img', 'click');
    };
    //根据等级、阶段设置结果页反馈
    CasePracticeStageEndComponent.prototype.setStageEndDocWithLevelAndStep = function (level, step) {
        level = level == 0 ? level : level - 1;
        this.yelp = this.stageDocument['step' + step]['summaries'][level];
        this.learningPointContent = this.stageDocument['step' + step]['learningPointContent'];
    };
    // 显示学习要点页面
    CasePracticeStageEndComponent.prototype.learningPointAct = function (act) {
        if (act == 'in') {
            $('.learning-point-wrap').fadeIn(200);
        }
        else if (act == 'out') {
            $('.learning-point-wrap').fadeOut(200);
        }
    };
    //获取当前阶段的导师反馈
    CasePracticeStageEndComponent.prototype.getTutorFeedback = function () {
        var _this = this;
        // this.isShowFireworks = false;
        // this.isShowReportLv = true;
        this.performanceService.getTutorFeedback(this.exerciseId, this.step + 1).subscribe(function (result) {
            console.log(_this.exerciseId);
            _this.resultLevel = result.level;
            // this.setResultContent(this.resultLevel);
            _this.isShowFireworks = false;
            _this.isShowReportLv = true;
        });
    };
    //指定标签禁止事件
    CasePracticeStageEndComponent.prototype.enableClickPreview = function (target, event) {
        var allITarget = this.el.nativeElement.querySelectorAll(target);
        allITarget.forEach(function (v) {
            v.addEventListener(event, function (e) {
                e.preventDefault();
            });
        });
    };
    //按钮点击事件
    CasePracticeStageEndComponent.prototype.btnAct = function (act) {
        switch (act) {
            case 'exit':
                this.onExit.emit();
                this.isShowLetter = false;
                break;
            // 关闭
            case 'close':
                console.log("休息一下");
                var that_1 = this;
                if (!that_1.clickAble) {
                    that_1.clickAble = true;
                    that_1.confirmBtnFlag = false;
                    that_1.onExit.emit();
                    setTimeout(function () {
                        that_1.clickAble = false;
                    }, 1000);
                    var exerciseMetaId_1 = $('#exerciseMetaId').val();
                    this.apiService.learingTime({ learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: "情景模拟", courseUnit: '', type: 2, btnName: exerciseMetaId_1, userId: localStorage.getItem("userId") }).subscribe(function (result) {
                        console.log(result);
                    });
                    console.log(exerciseMetaId_1);
                    this.commonService.sendPostMessage(1, 'isPractice' + 'Complete');
                }
                else {
                    return false;
                }
                break;
            // 继续
            case 'continue':
                this.onContinue.emit();
                break;
            // 进入二级页面
            case 'final':
                this.getTutorFeedback();
                break;
            // 查看报告
            case 'report':
                this.onReport.emit(true);
                var exerciseMetaId = $('#exerciseMetaId').val();
                this.apiService.learingTime({ learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: "情景模拟", courseUnit: '', type: 2, btnName: exerciseMetaId, userId: localStorage.getItem("userId") }).subscribe(function (result) {
                    console.log(result);
                });
                console.log("情景模拟做完！！");
                this.sendPostData();
                console.log(exerciseMetaId);
                this.commonService.sendPostMessage(2, 'isPractice' + 'Complete');
                break;
        }
    };
    CasePracticeStageEndComponent.prototype.sendPostData = function () {
        var _this = this;
        //向LMS平台传递进度数据
        if (localStorage.getItem("source_env") === "LMS_SCORM") {
            this.apiService.getUserQueryLearningProgress(Number(localStorage.getItem('learningPathMetaId'))).subscribe(function (res) {
                _this.commonService.sendDataMessage('type', 'LMS_LEARN_PROGRESS', res[0].progressList[0].progress, "data");
            });
        }
    };
    return CasePracticeStageEndComponent;
}());
export { CasePracticeStageEndComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-animation/case-practice-stage-end/case-practice-stage-end.component.ts.pre-build-optimizer.js